var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.700013C7.18333 0.883347 7.275 1.11668 7.275 1.40001C7.275 1.68335 7.18333 1.91668 7 2.10001L3.1 6.00001L7 9.90001C7.18333 10.0833 7.275 10.3167 7.275 10.6C7.275 10.8833 7.18333 11.1167 7 11.3C6.81667 11.4833 6.58333 11.575 6.3 11.575C6.01667 11.575 5.78333 11.4833 5.6 11.3L1 6.70001C0.9 6.60001 0.829 6.49168 0.787 6.37501C0.745667 6.25835 0.724999 6.13335 0.724999 6.00001C0.724999 5.86668 0.745667 5.74168 0.787 5.62501C0.829 5.50835 0.9 5.40001 1 5.30001L5.6 0.700013C5.78333 0.51668 6.01667 0.425012 6.3 0.425012C6.58333 0.425012 6.81667 0.51668 7 0.700013Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.44871ff0229a3075ffd1169e5069a5d9.svg";
export { ForwardRef as ReactComponent };